export default __webpack_public_path__ + "images/9c1ce12b2e325da64717b667093847a7.png";